import React from 'react'
import { TemplateRequestTable } from '../../../organism'

import i18n from '../../../../assets/i18n'
import { useVacancyRequestManagerReviewed } from '../../../../api/queries/useVacancyRequestManager'

const Reviewed = ({ rowSelected, setRowSelected, startDate, endDate, type, search }) => {
  const [page, setPage] = React.useState(0)
  const [perPage, setPerPage] = React.useState(10)
  const [range, setRange] = React.useState([0, 9])
  const [sort, setSort] = React.useState(['createdAt', 'desc'])

  const { data, isLoading } = useVacancyRequestManagerReviewed(range, sort, startDate, endDate, search)

  const getRange = (pageVal, perPageVal) => {
    return [pageVal * perPageVal, perPageVal * (pageVal + 1) - 1]
  }

  React.useEffect(() => {
    setRange(getRange(page, perPage))
  }, [page, perPage])

  return (
    <>
      <TemplateRequestTable
        data={data?.data}
        loading={isLoading}
        total={data?.total}
        i18n={i18n}
        rowSelected={rowSelected}
        setRowSelected={setRowSelected}
        page={page}
        setPage={setPage}
        perPage={perPage}
        setPerPage={setPerPage}
        range={range}
        setRange={setRange}
        sort={sort}
        setSort={setSort}
        showOpenProcesses={false}
        type={type}
      />
    </>
  )
}

export default Reviewed
